// extracted by mini-css-extract-plugin
module.exports = {"disabled":"BuildSelect_disabled__C8nzx","disabled__value":"BuildSelect_disabled__value__jaL8Y"};